import { CombinedState, combineReducers, Reducer, StateFromReducersMapObject } from 'redux';

import { baseApi } from '../api';
import applicationResultReducer from './reducers/application-result';
import { preliminaryInfoReducer } from './reducers/preliminaryInfo';
import { alertReducer, portalReducer } from '../app/reducers';
import configReducer from '../app/reducers/config';
import modalReducer from '../app/reducers/modal';
import { promotionReducer } from '../features/account/reducer/promotion';
import { referrerReducer } from '../features/account/reducer/referrer';
import { sessionReducer } from '../features/account/reducer/session';
import { addressLookupReducer } from '../features/address-verification/reducers/addressLookup';
import { analyticsReducer } from '../features/analytics/reducers/analytics-data';
import { businessInfoReducer } from '../features/application/reducers/business-info';
import { creditTermsReducer } from '../features/application/reducers/credit-terms.reducer';
import nextStepReducer from '../features/application/reducers/next-step';
import { personalInfoReducer } from '../features/application/reducers/personalInfo';
import otherIndividualsReducer from '../features/application-review/reducers/other-individuals.reducer';
import { documentRequirementsReducer } from '../features/document-collection/reducers/document-requirements.reducer';
import { startOrResumeApplicationReducer } from '../features/fleet-verification/reducers';
import { isSubaccountReducer } from '../features/fleet-verification/reducers/is-subaccount';
import { consentReducer } from '../features/legal-consent/reducers/consent';
import { personaReducer } from '../features/persona/reducers/persona';
import { bankAccountLinkingReducer } from '../features/revenue-verification/reducers/bank-account-linking.reducer';

const baseRootReducer = {
  addressLookup: addressLookupReducer,
  alert: alertReducer,
  analytics: analyticsReducer,
  applicationResult: applicationResultReducer,
  bankAccountLinking: bankAccountLinkingReducer,
  businessInfo: businessInfoReducer,
  config: configReducer,
  consent: consentReducer,
  creditTerms: creditTermsReducer,
  documentRequirements: documentRequirementsReducer,
  existingApplicantCheck: startOrResumeApplicationReducer,
  isSubaccount: isSubaccountReducer,
  modal: modalReducer,
  nextStep: nextStepReducer,
  otherIndividuals: otherIndividualsReducer,
  persona: personaReducer,
  personalInfo: personalInfoReducer,
  portal: portalReducer,
  preliminaryInfo: preliminaryInfoReducer,
  promotion: promotionReducer,
  referrer: referrerReducer,
  session: sessionReducer,
  [baseApi.reducerPath]: baseApi.reducer,
};

type BaseRootState = StateFromReducersMapObject<typeof baseRootReducer>;
export type RootState = BaseRootState;

const createRootReducer: () => Reducer<CombinedState<RootState>> = () =>
  combineReducers({
    ...baseRootReducer,
  });

export default createRootReducer;
